import React, { useContext } from "react";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../Store/Provider";

const MainLayout = (props) => {
  const context = useContext(StoreContext);
  const classes = useStyles();
  return (
    <div className="Home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>{props.children}</main>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default MainLayout;
